<template>
  <div class="editor">

    <PageHeader></PageHeader>
    <div class="editor-head">
      <div id="preview">
        <div id="preview-logo">
          <img src="../assets/static/logo2.png"/>
        </div>
        <img src="../assets/buttons/close.svg" class="close-btn" @click="hidePreview">
        <img v-if="!previewScale" src="../assets/buttons/zoom-in_bg-blue.svg" class="preview-scale-btn" @click="togglePreviewScale">
        <img v-if="previewScale" src="../assets/buttons/zoom-out_bg-blue.svg" class="preview-scale-btn" @click="togglePreviewScale">
        <div id="preview__holder"></div>
        <div id="preview__buttons">
          <div class="button-small" @click="hidePreview">{{ $t('editor_start_again') }}</div>
          <div class="button-small" @click="createCanvas">{{ $t('editor_download') }}</div>
          <div class="button-small" @click="restartApp">{{ $t('editor_delete_comic') }}</div>
        </div>
      </div>
      <div id="editor-head__left">
        <img src="../assets/buttons/preview.svg" class="head-btn" @click="createCanvas(true)">
        <img src="../assets/buttons/download.svg" class="head-btn" @click="createCanvas">
        <img src="../assets/buttons/zoom-in.svg" class="head-btn" @click="scaleUp">
        <img src="../assets/buttons/zoom-out.svg" class="head-btn" @click="scaleDown">
      </div>
      <div id="page-nav-header" class="editor-pagenav-center" v-if="pages.length > 1">
        <div v-bind:class="[currentPage < 1 ? 'editor__pagenav__button--disabled' : '', 'editor__pagenav__button']"><img
          src="../assets/buttons/arrow-left-blue.svg" @click="prevImageAction"></div>
        <div class="editor__pagenav__label">{{ $t('image') }} {{currentPage+1}}/{{pages.length}}</div>
        <div
          v-bind:class="[currentPage == (pages.length - 1) ? 'editor__pagenav__button--disabled' : '', 'editor__pagenav__button']">
          <img src="../assets/buttons/arrow-right-blue.svg" @click="nextImageAction"></div>
      </div>
      <div id="editor-head__right">
        <img v-if="activeElementType=='item'" src="../assets/buttons/turn-left.svg" class="head-btn" @click="turnLeft">
        <img v-if="activeElementType=='item'" src="../assets/buttons/turn-right.svg" class="head-btn" @click="turnRight">
        <img v-if="activeElementType=='item'" src="../assets/buttons/button_mirror.svg" class="head-btn" @click="toggleMirror">
        <img src="../assets/buttons/z-index_down.svg" class="head-btn" @click="sortDown">
        <img src="../assets/buttons/z-index_up.svg" key="upbtn" ref="uptn" class="head-btn" @click="sortUp">
        <img src="../assets/buttons/delete.svg" ref="deltebtn" key="deletebtn" class="head-btn"
             @mousedown.stop="deleteItem">
      </div>
    </div>
    <div id="editopr-wrapper">
      <transition name="fade">
        <bubble-editor name="bubbleeditor" id="bubble-editor-overlay" v-bind:initialValues="currentEditBubble"
                       v-if="showBubbleEditor" v-on:confirm="confirmBubble($event, obj)"
                       v-on:close="closeBubbleEditor"></bubble-editor>
      </transition>
      <transition name="fade">
        <div name="items" id="item-overlay" v-if="showItemOverlay">
          <img src="../assets/buttons/close.svg" class="close-btn" @click="closeOverlay">
          <h2>{{currentCategoryLabel}} </h2>
          <div class="item-select-overlay">
            <VueSlickCarousel id="item-select-overlay__slider" v-bind="settingsModal" ref="carouselItems"
                              @swipe="swipeAction" @afterChange="aftereChangeAction">
              <div class="nav-item" v-for="(item, index) in getAssetsData[this.currentCategory]" :key="'nav_' + index"
                   @click="addItem(item.url)">
                <div class="nav-item-overlay-div"></div>
                <img :src="'../items/' +item.url" class="assets__image">
                <div class="nav-item-shaddow"><img src="../assets/static/nav_item_shaddow.png"></div>
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </transition>
      <!-- ITEM OVERLAY -->
      <transition name="fade">
        <div name="items" id="item-overlay" v-if="showBgOverlay">
          <img src="../assets/buttons/close.svg" class="close-btn" @click="closeBgOverlay">
          <div class="item-select-overlay">
            <VueSlickCarousel id="item-select-overlay__slider" v-bind="settingsBg" ref="carouselBackgrounds"
                              @swipe="swipeAction" @afterChange="aftereChangeAction">
              <div class="nav-item" v-for="(item, index) in getAssetsData['backgrounds']" :key="'bgnav_' + index"
                   @click="selectDefaultBg(item.url)">
                <div class="nav-item-overlay-div"></div>
                <img :src="'../items/' +item.url" class="bg__image">
              </div>
            </VueSlickCarousel>
          </div>
        </div>
      </transition>
      <!--STAGE -->
      <div id="stage" :style="{ transform: 'scale('+ pageScale+') translate(-50%, '+pagePadding+'px)', width: getcurrentPageWidth(currentPage) +'px', height: getcurrentPageHeight(currentPage)+'px'}"
           class="aspect-element">
        <div v-if="currentPage == (pages.length -1)" id="view-comic-btn" @click="createCanvas(true)">
          {{ $t('view-comic-btn') }}
        </div>
        <div id="comic">
          <div id="preview__title">{{getTitle}}</div>
          <!-- PAGES -->
          <div v-for="(page, pageIndex) in pages" :id="'page-container-content-'+pageIndex"
               class="page-container-page aspect-element" v-show="currentPage==pageIndex"
               :key="'page-elemet' + pageIndex" :data-pagenum="pageIndex" :style="{'width': getcurrentPageWidth(pageIndex) +'px', 'height': getcurrentPageHeight(pageIndex)+'px'}">
            <!--PAGE - IMAGE HOLER -->

            <div class="page aspect-element" :data-pagenum="pageIndex" v-show="!editBg" :style="{'width': getcurrentPageWidth(pageIndex) +'px', 'height': getcurrentPageHeight(pageIndex)+'px'}">
              <div :id="'bubbleholder_'+pageIndex">
                <vue-draggable-resizable v-if="!bubbble.deleted"
                                         v-for="(bubbble, bubble_index) in bubbleList[pageIndex]"
                                         :id="'bubble_'+pageIndex+'_'+ bubble_index" class-name-handle="item-handle" :w="10" :h="10"
                                         :z="bubble_index" class-name-dragging="my-dragging-classa" :handles="[]"
                                         :lock-aspect-ratio="true" @activated="onActivateBubble(bubble_index)"
                                         :onDragStart="onBubbleDragStart" @dragging="onDrag" :resizeable="false"
                                         :draggable="speechBubbleDraggable" :parent="false"
                                         v-bind:item="bubbble"
                                         v-bind:index="bubble_index"
                                         v-bind:key="'page_bubble_element_' + pageIndex +'_'+ bubble_index"
                                         :ref="'page_bubble_' + pageIndex +'_'+ bubble_index"
                                         v-bind:scale="pageScale"
                                         class-name="drag__element"
                                         data-type="bubble"
                                         :data-curId="bubble_index"
                                         @deactivated="onDeactivateBubble(bubble_index)"
                ></vue-draggable-resizable>
                <!--    <div v-for="(bubbble, bubble_index) in bubbleList[pageIndex]"  :id="'xbubble_'+bubble_index" >XYZ</div>-->
              </div>

              <vue-draggable-resizable v-if="!item2.deleted" v-for="(item2, index2) in pages[pageIndex]"
                                       class-name-handle="item-handle" :w="auto" :h="auto" :z="index2"
                                       :handles="['tl','tr','bl','br']" :lock-aspect-ratio="true"
                                       @activated="onActivate" :onDragStart="onDragStart" @dragging="onDrag"
                                       @resizing="onResize" :parent="false"
                                       v-bind:item="item2"
                                       v-bind:index="index2"
                                       v-bind:key="'page_' + '_'+ index2"
                                       v-bind:scale="pageScale"
                                       class-name="drag__element"
                                       data-type="item"
                                       :data-mirror="item2.mirror"
              ><img :src="'/'+ getItemSource(item2.mirror)+'/'+ item2.src+'?' + '_'+ index2" :id="'item_'+pageIndex+'_'+index2"
                    :data-listid="index2" width="50" class="drag__element__image" :key="'item_'+pageIndex+'_'+index2"
                    data-type="item">

              </vue-draggable-resizable>
            </div>
            <!--
            </div>
            -->
            <!-- BACKGROUND IAMGE -->
            <div :id="'imageholder_'+pageIndex" v-if="pagesPackgroundsOptions[pageIndex] != null"
                 class="imageholder aspect-element" :data-pagenum="pageIndex" :style="{'width': getcurrentPageWidth(pageIndex) +'px', 'height': getcurrentPageHeight(pageIndex)+'px'}">
              <vue-draggable-resizable :w="pagesPackgroundsOptions[pageIndex].width" classNameActive="activeItem"
                                       class-name-handle="item-handle" :h="pagesPackgroundsOptions[pageIndex].height"
                                       :x="pagesPackgroundsOptions[pageIndex].startX" :y="pagesPackgroundsOptions[pageIndex].startY" :handles="['tl','tr','bl','br']" :lock-aspect-ratio="true"
                                       v-bind:scale="pageScale" :id="'imageholder__drag-holder_'+pageIndex"
                                       :active="editBg"
                                       @dragging="onDrag"
                                       @resizing="onResize"
                                       class-name="bg__drag_element"
                                       :parent="false">
                <img :class="pagesPackgroundsOptions[pageIndex].class" :src="pagesPackgrounds[pageIndex]" data-type="background"/>
              </vue-draggable-resizable>
            </div>
          </div>

        </div>

      </div>

      <transition name="fade">
        <div id="background-editor" v-if="editBg">
          <!-- <img src="../assets/buttons/close.svg" class="close-btn" @click="endBgEdit">-->

          <input type="file" id="myfile" @change="loadBgImage" accept="image/*" name="myfile" ref="file"
                 style="display: none">
          <div v-if="!pagesPackgrounds[currentPage]" class="button-big" @click="$refs.file.click()">{{
            $t('bgedit_select_image') }}
          </div>
          <div v-if="pagesPackgrounds[currentPage]" class="button-big" @click="$refs.file.click()">{{
            $t('bgedit_change_image') }}
          </div>
          <div class="button-big" @click="showBgImages">{{ $t('bgedit_default_images') }}</div>
          <div class="button-big" @click="endBgEdit">OK</div>
        </div>
      </transition>
      <div id="page-nav-footer" class="editor-pagenav-center" v-if="pages.length > 1">
        <div v-bind:class="[currentPage < 1 ? 'editor__pagenav__button--disabled' : '', 'editor__pagenav__button']"><img
          src="../assets/buttons/arrow-left-blue.svg" @click="prevImageAction"></div>
        <div class="editor__pagenav__label">{{ $t('image') }} {{currentPage+1}}/{{pages.length}}</div>
        <div
          v-bind:class="[currentPage == (pages.length - 1) ? 'editor__pagenav__button--disabled' : '', 'editor__pagenav__button']">
          <img src="../assets/buttons/arrow-right-blue.svg" @click="nextImageAction"></div>
      </div>

      <div class="editor-footer">

        <VueSlickCarousel v-if="!editBg" id="editor-footer__item-slider" v-bind="settingsFooter" ref="footer-slider"
                          @swipe="swipeAction" @afterChange="aftereChangeAction">
          <div class="footer-btn" @click="startBgEdit">
            <div class="nav-item-overlay-div"></div>
            <img class="footer-btn__image" src="../assets/static/button_sprechblasen.png">
            <div class="footer-btn__label">{{ $t('editor_set_bg') }}</div>
          </div>
          <div class="footer-btn" @click="addTextBubble">
            <div class="nav-item-overlay-div"></div>
            <img class="footer-btn__image" src="../assets/static/button_text.png">
            <div class="footer-btn__label">{{ $t('editor_bubble') }}</div>
          </div>

          <div class="footer-btn" @click="showItems('bubbles_'+ $i18n.locale.toLowerCase(), $t('editor_bubble') )">
            <div class="nav-item-overlay-div"></div>
            <img class="footer-btn__image" src="../assets/static/button_bubbles.png">
            <div class="footer-btn__label">{{ $t('editor_bubble') }}</div>
          </div>

          <div class="footer-btn" @click="showItems('effekte', $t('editor_comic_effects') )">
            <div class="nav-item-overlay-div"></div>
            <img class="footer-btn__image" src="../assets/static/button_effekte.png">
            <div class="footer-btn__label">{{ $t('editor_comic_effects') }}</div>
          </div>
          <div class="footer-btn" @click="showItems('novelmore', 'Novelmore')">
            <div class="nav-item-overlay-div"></div>
            <img class="footer-btn__image" src="../assets/static/button_novelmore.png">
            <div class="footer-btn__label">Novelmore</div>
          </div>
          <div class="footer-btn" @click="showItems('everdreamerz', 'EverDreamerz')">
            <div class="nav-item-overlay-div"></div>
            <img class="footer-btn__image" src="../assets/static/button_dreamerz.png">
            <div class="footer-btn__label">EverDreamerz</div>
          </div>
          <div class="footer-btn" @click="showItems('heroes', $t('editor_heroes'))">
            <div class="nav-item-overlay-div"></div>
            <img class="footer-btn__image" src="../assets/static/button_heldinnen.png">
            <div class="footer-btn__label">{{ $t('editor_heroes') }}</div>
          </div>
          <div class="footer-btn" @click="showItems('city', 'City Life')">
            <div class="nav-item-overlay-div"></div>
            <img class="footer-btn__image" src="../assets/static/button_citylife.png">
            <div class="footer-btn__label">City Life</div>
          </div>
          <div class="footer-btn" @click="showItems('robert', 'ROBert')">
          <div class="nav-item-overlay-div"></div>
          <img class="footer-btn__image" src="../assets/static/button_robert.png">
          <div class="footer-btn__label">ROBert</div>
        </div>
        </VueSlickCarousel>

      </div>
    </div>

  </div>

</template>

<script>
  /* eslint-disable */
  // @ is an alias to /src
  import 'file-saver'
  import 'canvas-toBlob'
  import 'html2canvas'
  import VueSlickCarousel from 'vue-slick-carousel'
  import 'vue-slick-carousel/dist/vue-slick-carousel.css'
  import BubbleManager from '../BubbleManager'
  // optional style for arrows & dots
  import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
  import VueDraggableResizable from 'vue-draggable-resizable'
  import axios from 'axios'
  import * as loadImage from 'blueimp-load-image'
  import PageHeader from './PageHeader'
  import BubbleEditor from './BubbleEditor'
  import CustomSpeechBubble from '../CustomSpeechBubble'

  export default {
    name: 'Editor2',
    components: {
      VueSlickCarousel,
      PageHeader,
      BubbleEditor
    },
    data: function () {
      return {
       // stageWidth: 600,
       // stageHeight: 400,
        stageSizeList: [{
          w: this.stageWidth,
          h: this.stageHeight
        }],
        canvasElement: null,
        canvasElement2: null,
        pages: [],
        bubbleList: [],
        currentEditBubble: null,
        pagesPackgrounds: [],
        pagesPackgroundsOptions: [],
        pageScale: 1,
        pagePadding: 0,
        width: 0,
        height: 0,
        x: 0,
        y: 0,
        currentGrid: 0,
        currentPage: 0,
        currentCategory: '',
        currentCategoryLabel: '',
        activeElement: '',
        activeElementType: '',
        showItemOverlay: false,
        showBgOverlay: false,
        showBubbleEditor: false,
        previewScale: false,
        bgCanvas: null,
        bgCanvas2: null,
        bgProps: null,
        editBg: false,
        speechBubbleDraggable: true,
        elements: [],
        elements2: [],
        settings1: {
          dots: true,
          'dotsClass': 'slick-dots custom-dot-class',
          infinite: false,
          speed: 500,
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: true,
          draggable: false,
          touchMove: false
        },
        sliderClickable: true,
        settingsModal: {
          dots: false,
          infinite: false,
          slidesToShow: 6,
          slidesToScroll: 6,
          arrows: true,
          draggable: true,
          rows: 1,

          touchMove: true,
          adaptiveHeight: false,
          responsive: [
            {
              'breakpoint': 1000,
              'settings': {
                'slidesToShow': 5,
                'slidesToScroll': 5,
              }
            },
            {
              'breakpoint': 900,
              'settings': {
                'slidesToShow': 4,
                'slidesToScroll': 4,
              }
            },
            {
              'breakpoint': 670,
              'settings': {
                'slidesToShow': 3,
                'slidesToScroll': 3
              }
            },
            {
              'breakpoint': 485,
              'settings': {
                'slidesToShow': 2,
                'slidesToScroll': 2
              }
            },
            {
              'breakpoint': 390,
              'settings': {
                'slidesToShow': 2,
                'slidesToScroll': 2
              }
            }
          ]
        },
        settingsBg: {
          dots: false,
          infinite: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: true,
          draggable: true,
          rows: 1,

          touchMove: true,
          adaptiveHeight: false,
          responsive: [
            {
              'breakpoint': 900,
              'settings': {
                'slidesToShow': 3,
                'slidesToScroll': 3,
              }
            },

            {
              'breakpoint': 870,
              'settings': {
                'slidesToShow': 2,
                'slidesToScroll': 2
              }
            },
            {
              'breakpoint': 580,
              'settings': {
                'slidesToShow': 1,
                'slidesToScroll': 1
              }
            }
          ]
        },
        settingsFooter: {
          slidesToShow: 7,
          responsive: [
            {
              'breakpoint': 950,
              'settings': {
                'slidesToShow': 5,
                'slidesToScroll': 5,
              }
            },
            {
              'breakpoint': 710,
              'settings': {
                'slidesToShow': 4,
                'slidesToScroll': 4,
              }
            },
            {
              'breakpoint': 661,
              'settings': {
                'slidesToShow': 3,
                'slidesToScroll': 3
              }
            },
            {
              'breakpoint': 438,
              'settings': {
                'slidesToShow': 2,
                'slidesToScroll': 2
              }
            }
          ]
        }

      }
    },
    mounted () {

      window.track('Editor')

      //set pages
      let pageCount = 1

      switch (this.getGrid()) {
        case 0:
          pageCount = 1
          this.stageSizeList = [{
            w: 600,
            h: 400
          }, {
            w: 600,
            h: 400
          }]
          //  this.bubbleList = [[]];
          break
        case 1:
          pageCount = 2
          this.stageSizeList = [{
            w: 600,
            h: 400
          }, {
            w: 600,
            h: 400
          }]
          //  this.bubbleList = [[], []];
          break
        case 2:
          pageCount = 3
          this.stageSizeList = [{
            w: 600,
            h: 400
          }, {
            w: 600,
            h: 400
          }, {
            w: 600,
            h: 400
          }]
          // this.bubbleList = [[], [], []];
          break
        case 3:
          pageCount = 4
          this.stageSizeList = [{
            w: 600,
            h: 400
          }, {
            w: 600,
            h: 400
          }, {
            w: 600,
            h: 400
          }, {
            w: 600,
            h: 400
          }]
          // this.bubbleList = [[], [], [], []];
          break

        case 4:
          pageCount = 4
          this.stageSizeList = [{
            w: 600,
            h: 400
          }, {
            w: 1200,
            h: 400
          }, {
            w: 1200,
            h: 400
          }, {
            w: 600,
            h: 400
          }]
          // this.bubbleList = [[], [], [], []];
          break
        case 5:
          pageCount = 5
          this.stageSizeList = [{
            w: 600,
            h: 600
          }, {
            w: 600,
            h: 600
          }, {
            w: 1205,
            h: 400
          }, {
            w: 600,
            h: 600
          }, {
            w: 600,
            h: 600
          }]
          // this.bubbleList = [[], [], [], []];
          break
        case 6:
          pageCount = 5
          this.stageSizeList = [{
            w: 400,
            h: 400
          }, {
            w: 400,
            h: 400
          }, {
            w: 400,
            h: 400
          }, {
            w: 602.5,
            h: 400
          }, {
            w: 602.5,
            h: 400
          }]
          // this.bubbleList = [[], [], [], []];
          break
      }
      for (let i = 0; i < pageCount; i++) {
        this.pages.push([])
        this.pagesPackgrounds.push(null)
        this.pagesPackgroundsOptions.push(null)
        this.bubbleList.push([])

      }

      this.pageScale = Number(this.getStageScale())
      let editorHeight = Number($(window).innerHeight())
      let editorWrapperHeight = Number($(window).innerHeight()) - 68 - 66
      $('#editopr-wrapper').css('height', editorWrapperHeight)
      $('.editor').css('height', editorHeight)
      var that = this
      let t = setTimeout(function () {
        that.onWindowResize()
      }, 1000)
      this.$nextTick(function () {
        $('body').addClass('overflow-hidden')
        //this.pagePadding = Number(this.getStagePadding())
        window.addEventListener('resize', this.onWindowResize)
        this.onInitPageSize()
        this.onWindowResize()
        this.bubbleManager = new BubbleManager($('#bubbleholder_0')[0], this)

      })

    },
    created () {
      if (this.getAssetsData == null) {
        this.$router.push({ name: 'loaderpage' })
      }

    },
    destroyed () {
      //console.log ('destroyed'),
      $('body').removeClass('overflow-hidden')
    },

    methods: {

      onInitPageSize () {

       // $('.aspect-element').width(this.stageSizeList[this.currentPage].w)
       // $('.aspect-element').height(this.stageSizeList[this.currentPage].h)
        $('.aspect-element').each(function (el) {
         //   console.log($(this))
        });


      //  $('.aspect-element').css('border', '1px solid red')
      },

      onWindowResize () {
        this.getHeightStats()
        let editorHeight = Number($(window).innerHeight())
        let editorWrapperHeight = Number($(window).innerHeight()) - 68 - 66
        $('#editopr-wrapper').css('height', editorWrapperHeight)
        $('.editor').css('height', editorHeight)
        this.pageScale = Number(this.getStageScale());
        this.$nextTick(function () {
          this.pagePadding = Number(this.getStagePadding())
        })

      },
      getHeightStats () {

      },

      reInitSlider () {
      },
      initSlider () {
      },
      viewport () {
        var e = window, a = 'inner'
        if (!('innerWidth' in window)) {
          a = 'client'
          e = document.documentElement || document.body
        }
        //console.log ( e[a + 'Height'])
        return {
          width: e[a + 'Width'],
          height: e[a + 'Height']
        }
      },
      getStageScale () {
        let v = this.viewport()
        let w = v.width
        let h = v.height
        let f = 1
        let maxH = h - $('.editor-head').height() - 66 - $('.editor-footer').height() - 50

        let aspect = this.stageWidth / this.stageHeight
        let nw = w - 20
        let nh = w / aspect

        if (nh > maxH) {
          //  nh = maxH;
          //nw = nh * f;
        } else {

        }
        let s = nw / this.stageWidth
        nh = this.stageHeight * s
        s = nw / this.stageWidth

        if (nh > maxH) {
          //console.log ("Height Issue")
          nh = maxH
          nw = nh * aspect

          s = nh / this.stageHeight
        }

        return s
      },
      getStagePadding () {
        let maxH = $('#editopr-wrapper').height() - $('.editor-footer').height() - 80
        //console.log ("maxH", maxH)
        let s = document.getElementById('stage').getBoundingClientRect().height
        //console.log ("s", s)
        let p = (maxH - s) / 2
        if (p < 0) {
          p = 0
        }
        return p
      },
      switchPage (id) {
        this.currentPage = id

      },
      selectDefaultBg (src) {
        if (this.sliderClickable) {
          this.pagesPackgrounds[this.currentPage] = '../items/' + src
          let w = this.stageWidth;
          let h = w  / 1.5;
          let startX = 0;
          let startY = 0;
          let aspectClass = 'landscape';
          if (h < this.stageHeight){
            h = this.stageHeight
            w = h * 1.5
            aspectClass = 'portrait';
          }
          startX = this.stageWidth - w ;
          startY = this.stageHeight - h;
          if (startX != 0){
            startX /= 2;
          }
          if (startY != 0){
            startY /= 2;
          }
          this.pagesPackgroundsOptions[this.currentPage] = {
            'width': w,
            'height': h,
            'startX': startX,
            'startY:': startY,
            'aspectClass:': aspectClass
          }
          this.showBgOverlay = false
        }

      },

      loadBgImage (e) {

        var that = this
        this.pagesPackgrounds[this.currentPage] = null
        let bgsrc

        bgsrc = e.target.files[0]

        loadImage(bgsrc
          ,
          function (img, data) {

            let store = $('.imageholder__drag-holder_0')
            //store.innerHTML = '<img src="' + img + '">';
            store.empty()

            let w, h

            w = data.originalWidth
            h = data.originalHeight
            let aspectClass = 'landscape';
            let f = w / h
            if (w > that.stageWidth) {
              w = that.stageWidth
              h = w / f
               aspectClass = 'portrait';

            }

            that.pagesPackgrounds[that.currentPage] = img.toDataURL()
            that.pagesPackgroundsOptions[that.currentPage] = {
              'width': w,
              'height': h,
              'startX': 0,
              'startY:': 0,
              'aspectClass:': aspectClass

            }
            that.$forceUpdate()

          },
          {

            orientation: true,
            canvas: true,
            meta: true,
            noRevoke: true,
            maxWidth: 1200// Options

          } // Options
        )
        /*
                const file = ev.target.files[0];
                const reader = new FileReader();

                reader.onload = e => this.imageHandler(e.target.result);
                reader.readAsDataURL(file);
                */

      },
      imageHandler (e2) {
        var store = document.getElementById('imageholder')
        store.innerHTML = '<img src="' + e2 + '">'
      },
      saveCanvas () {
        this.canvasElement.toBlob(function (blob) {
          saveAs(blob, 'myImage.png')
        })
      },
      createCanvas (previewFlag = false) {
        //  $('.page-container-page').css('position' , 'absolute');

        //FIX SVG

        //Hide Elemetns
        this.showItemOverlay = false,
          this.showBgOverlay = false,
          $('.page-container-page').show()
        let borderStr = '5px solid white'
        let obj = {}

        //POSITION ELEMENTS
        switch (this.getGrid()) {
          case 0:
            obj = {
              display: 'flex',
              width: '610px',
              flexWrap: 'wrap',
              backgroundColor: 'white'
            }
            $('#page-container-content-0').css({ border: '5px solid white' })
            break
          case 1:
            // $('#page-container-content-0').css({top: 0, left: 0, })
            // $('#page-container-content-1').css({top: 400, left: 0})
            $('#page-container-content-0').css({ border: '5px solid white' })
            $('#page-container-content-1').css({
              borderLeft: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            obj = {
              display: 'flex',
              width: '610px',
              flexWrap: 'wrap',
              backgroundColor: 'white'
            }
            break
          case 2:
            $('#page-container-content-0').css({ border: '5px solid white' })
            $('#page-container-content-1').css({
              borderLeft: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-2').css({
              borderLeft: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            obj = {
              display: 'flex',
              width: '610px',
              flexWrap: 'wrap '
            }
            break
          case 3:
            $('#page-container-content-0').css({ border: borderStr })
            $('#page-container-content-1').css({
              borderTop: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-2').css({
              borderLeft: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-3').css({
              borderBottom: borderStr,
              borderRight: borderStr
            })
            obj = {
              display: 'flex',
              width: '1225px',
              flexWrap: 'wrap'
            }
            break
          case 4:
            $('#page-container-content-0').css({ border: borderStr })
            $('#page-container-content-1').css({
              borderTop: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-2').css({
              borderLeft: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-3').css({
              borderBottom: borderStr,
              borderRight: borderStr
            })

            obj = {
              display: 'flex',
              width: '1825px',
              flexWrap: 'wrap'
            }
            break
          case 5:
            $('#page-container-content-0').css({ border: borderStr })
            $('#page-container-content-1').css({
              borderTop: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-2').css({
              borderLeft: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-3').css({
              borderLeft: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-4').css({
              borderBottom: borderStr,
              borderRight: borderStr
            })
            obj = {
              display: 'flex',
              width: '1225',
              flexWrap: 'wrap'
            }
            break
          case 6:
            $('#page-container-content-0').css({ border: borderStr })
            $('#page-container-content-1').css({
              borderTop: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-2').css({
              borderTop: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-3').css({
              borderLeft: borderStr,
              borderBottom: borderStr,
              borderRight: borderStr
            })
            $('#page-container-content-4').css({

              borderBottom: borderStr,
              borderRight: borderStr
            })

            obj = {
              display: 'flex',
              width: '1225',
              flexWrap: 'wrap'
            }
            break

        }
        $('#comic').css(obj)
        /*
        $('.imageholder').css({
          width: '590px',
          height: '390px',
        });
        */
        $('#preview__title').show()
        // var svgElements = document.body.querySelectorAll('svg');
        //$('#page-container-content-0').css('top', 0)
        // $('#page-container-content-1').css('top', 400)

        this.pageScale = 1
        var th = this
        this.unsetActiveElement()

        this.$nextTick(() => {
          let options = {
            logging: false,
            removeContainer: false,
            imageTimeout: 0,
            allowTaint: true
          }

          html2canvas(document.getElementById('comic', options)).then(function (canvas) {
            th.pageScale = th.getStageScale()
            th.resetPreviewProps()
            if (previewFlag == true) {
              $('#preview__holder').html('')

              $('#preview__holder').append(canvas)
              $('#preview').show()
              let h = $(window).innerHeight() - $('#preview__buttons').height() - 120
              $('#preview__holder').css('height', h)
              let w =  $('#preview__holder').width();
              let cw = $(canvas).width();
              let ch = $(canvas).height();
              let canvasFaktor = cw / ch;
              let nw;
              let nh;

              let scaleFactor =  (h-10) / ch;
              nh  = ch * scaleFactor
              nw  = cw * scaleFactor
              if(nw > $('#preview__holder').width()){
                  nw = $('#preview__holder').width() -10
                  nh = nw / canvasFaktor
              }

              $('#preview__holder canvas').css('height', nh + 'px');
              $('#preview__holder canvas').css('width',nw + 'px');


              var that = this
              let t = setTimeout(function () {
                th.setPreviewZoomBtnPosition()
              }, 100)




            } else {
              $('#preview').hide()
              canvas.toBlob(function (blob) {
                window.track('Editor', 'SaveComic')
                saveAs(blob, 'comic.png')

              })
            }

          })
        })

      },
      togglePreviewScale(){
            this.previewScale = !this.previewScale
            if (this.previewScale){
              $('#preview__holder canvas').addClass('preview-scaled');
            }else{
              $('#preview__holder canvas').removeClass('preview-scaled');
            }
            this.setPreviewZoomBtnPosition();
      },

      setPreviewZoomBtnPosition(){
        let px;
        let py;
        if(this.previewScale){
          px =  $('#preview__holder canvas').width() -   $('.preview-scale-btn').width() + $('#preview__holder canvas').offset().left //$(window).width() / 2
          py = $('#preview__holder canvas').offset().top
        }else{
          px =  $('#preview__holder canvas').width() -   $('.preview-scale-btn').width() + $('#preview__holder canvas').offset().left //$(window).width() / 2
          py = $('#preview__holder canvas').offset().top
        }

        $('.preview-scale-btn').css('left',px );
        $('.preview-scale-btn').css('top',py );

      },
      resetPreviewProps () {
        $('#comic').css({
          display: 'block',
          width: '600px',
        })
        $('.page-container-page').css({
          border: 'none'
        })

        $('#preview__title').hide()
        $('.page-container-page').hide()
        $('#page-container-content-' + this.currentPage).show()
        /*
         $('.imageholder').css({
           width: '600px',
           height: '400px',
         });
         */
      },
      onResize: function (x, y, width, height) {

        this.x = x
        this.y = y
        this.width = width
        this.height = height

      },
      onDrag: function (x, y) {
        this.x = x
        this.y = y
      },

      addItem (src) {
        if (this.sliderClickable) {
          this.showItemOverlay = false
          let newItem = {
            src: src,
            x: 300,
            y: 200,
            deleted: false,
            type: 'item',
            mirror: false
          }
          this.pages[this.currentPage].push(newItem)
          //this.elements.push(newItem)

        }

      },
      scaleUp () {
        this.pageScale += 0.2
        if (this.pageScale > 1) {
          // this.pageScale = 1;
        }
      },
      scaleDown () {
        this.pageScale -= 0.2
        if (this.pageScale < 0.1) {
          this.pageScale = 0.1
        }
      },
      showItems (cat, label) {
        if (this.sliderClickable) {
          window.track('Editor', 'Itemselect_' + label)

          this.currentCategory = cat
          this.currentCategoryLabel = label
          this.showItemOverlay = true
          try {
            this.$refs.carouselItems.goTo(0)
          } catch (e) {
            // console.log ("got not working")
          }

        }
      },
      addTextBubble () {
        this.currentEditBubble = null
        this.showBubbleEditor = true

      },
      editTextBubble (val) {
        this.currentEditBubble = this.bubbleList[this.currentPage][val]

        this.showBubbleEditor = true
      },
      toggleDraggable (val) {
        this.speechBubbleDraggable = val
      },
      confirmBubble (obj) {
        this.unsetActiveElement();

        if (obj.id == null) {
          let newBubble = {
            data: obj,
            x: 300,
            y: 200,
            deleted: false,
            type: 'speechbubble',
            instanceHolder: null
          }
          this.showBubbleEditor = false
          this.bubbleList[this.currentPage].push(newBubble)
          var curlength = this.bubbleList[this.currentPage].length - 1
          var bid = 'bubble_'+this.currentPage+'_' + curlength
          var valobj = obj

          this.$nextTick(function () {

            // this.bubbleManager.addBubble(50, 50, $('#'+bid)[0]);
            let newBubble = new CustomSpeechBubble(this, $('#' + bid)[0], 50, 50, this, curlength)

            newBubble.setValues(valobj)
            newBubble.updateInitialTail()
            this.bubbleList[this.currentPage][curlength].instanceHolder = newBubble
            this.toggleDraggable(true)
            this.activeElement = $('#' + bid)[0]


          })
        } else {
          this.showBubbleEditor = false
          let curBubble = this.bubbleList[this.currentPage][obj.id]
          curBubble.instanceHolder.setValues(obj)
          this.currentEditBubble = null
        }

      },
      closeBubbleEditor () {
        this.showBubbleEditor = false
      },
      closeOverlay () {
        this.showItemOverlay = false
      },
      hideItems () {
        this.$modal.hide('items')
      },
      onActivate (el) {
      },
      onActivateBubble (id) {
        //  this.activeElement = elem

      },

      onBubbleDragStart (el) {
        this.unsetActiveElement()
        this.activeElement = el.currentTarget


      },
      onDragStart (el) {
        this.activeElement = el.target
        this.setActiveElement()

      },
      nextImageAction () {
        if (this.currentPage < this.pages.length - 1) {
          this.currentPage++
          this.onInitPageSize()
        }
      },
      prevImageAction () {

        if (this.currentPage > 0) {
          this.currentPage--

          this.onInitPageSize()
        }
      },

      startBgEdit () {
        this.editBg = true
      },
      showBgImages () {
        this.showBgOverlay = true
      },
      closeBgOverlay () {
        this.showBgOverlay = false
      },
      endBgEdit () {
        this.editBg = false
      },
      getBgActive () {
        if (this.editBg == true) {
          return true
        } else {
          return false
        }
      },
      turnLeft () {

        if (this.activeElement) {
          let curRotate = this.getCurrentRotation((this.activeElement))
          let nextRotate = curRotate -= 10
          $(this.activeElement).css({ 'transform': 'rotate(' + nextRotate + 'deg)' })
        }
      },
      turnRight () {
        if (this.activeElement) {
          let curRotate = this.getCurrentRotation((this.activeElement))
          let nextRotate = curRotate += 10
          $(this.activeElement).css({ 'transform': 'rotate(' + nextRotate + 'deg)' })

        }
      },
      toggleMirror () {


        if (this.activeElementType == 'item') {
          const key = $(this.activeElement).data('listid')

          this.pages[this.currentPage][key].mirror = !this.pages[this.currentPage][key].mirror
        }

      },
      sortUp () {
        let el = $(this.activeElement).closest('.drag__element')
        let maxz = el.css('z-index')
        maxz++
        el.css('z-index', maxz)
      },
      sortDown () {
        let el = $(this.activeElement).closest('.drag__element')
        let maxz = el.css('z-index')
        maxz--
        el.css('z-index', maxz)
      },
      deleteItem (evt) {
        if (this.activeElementType == 'item') {
          const key = $(this.activeElement).data('listid')

          this.pages[this.currentPage][key].deleted = true
        } else if (this.activeElementType == 'bubble') {

          const key = $(this.activeElement).data('curid')
          this.bubbleList[this.currentPage][key].deleted = true
        }

        this.unsetActiveElement()
      },
      setActiveElement () {
        this.unsetActiveElement()
        $(this.activeElement).addClass('activeItem')
      },
      unsetActiveElement () {
        $('.activeItem').removeClass('activeItem')
        if ($(this.activeElement).data('type') == 'bubble'){
          let curid = $(this.activeElement).data('curid')
          let curBubble = this.bubbleList[this.currentPage][curid]
          curBubble.instanceHolder.deActivateElement()
          this.activeElement = null
          this.activeElementType = null;
        }
      },

      getGrid () {

        return this.$store.state.selectdGrid
      },

      getcurrentPageWidth(pageNum){
          return this.stageSizeList[pageNum].w
      },
      getcurrentPageHeight(pageNum){
        return this.stageSizeList[pageNum].h
      },
      hidePreview () {
        $('#preview').hide()
      },
      restartApp () {
        this.$router.push('titlepage')
      },
      getCurrentRotation (el) {
        var st = window.getComputedStyle(el, null)
        var tm = st.getPropertyValue('-webkit-transform') ||
          st.getPropertyValue('-moz-transform') ||
          st.getPropertyValue('-ms-transform') ||
          st.getPropertyValue('-o-transform') ||
          st.getPropertyValue('transform') ||
          'none'
        if (tm != 'none') {
          var values = tm.split('(')[1].split(')')[0].split(',')
          //return Math.round(Math.atan2(values[1],values[0]) * (180/Math.PI)); //this would return negative values the OP doesn't wants so it got commented and the next lines of code added
          var angle = Math.round(Math.atan2(values[1], values[0]) * (180 / Math.PI))
          return (angle < 0 ? angle + 360 : angle) //adding 360 degrees here when angle < 0 is equivalent to adding (2 * Math.PI) radians before
        }
        return 0
      },
      swipeAction () {
        this.sliderClickable = false
        var that = this
        let t = setTimeout(function () {
          that.sliderClickable = true
        }, 1000)
      },
      aftereChangeAction () {
        this.sliderClickable = true
      },
      onDeactivateBubble (index) {

      },
      getItemSource(isMirror){
        if (!isMirror) {
          return 'items'
        }else{
          return 'items - Kopie'

        }
      }

    },
    computed: {
      getTitle () {
        return this.$store.state.title
      },

      getAssetsData () {

        return this.$store.state.assetsData
      },
      stageWidth () {
        return this.stageSizeList[this.currentPage].w
      }
      ,
      stageHeight () {
        return this.stageSizeList[this.currentPage].h
      }


    },
    watch: {
      activeElement: function (newVal, oldVal) {

        if ($(oldVal).data('type') == 'bubble'){
          let curid = $(oldVal).data('curid')
          let curBubble = this.bubbleList[this.currentPage][curid]
          curBubble.instanceHolder.deActivateElement()
        }
        this.activeElementType  = $(this.activeElement).attr('data-type')

        if (this.activeElementType == 'bubble') {
          let curid = $(this.activeElement).data('curid')
          let curBubble = this.bubbleList[this.currentPage][curid]
          curBubble.instanceHolder.activateElement()

        }
      },

    }

  }
</script>
<style scoped lang="scss">

  #preview {
    position: fixed;
    display: none;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    background: url('~@/assets/static/bg_blasen.jpg');
    background-size: cover;
    background-position: 50% 50%;
    .preview-scale-btn{
      position: absolute;

      width: 40px;
      height: 40px;

    }
    #preview-logo {
      position: absolute;
      width: 150px;

      img {
        width: 100%;
        height: auto;
      }

    }

    #preview__buttons {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-around;
      max-width: 1000px;
      margin: 0 auto;
      padding-top: 20px;
      padding-bottom: 20px;
      @media (max-width: 850px) {
        margin: 0 auto;
        width: 300px;
      }
    }

    #preview__holder {
      width: 90%;
      height: 200px;
      overflow-y: auto;

      margin: 0 auto;
      margin-top: 15px;
      margin-bottom: 15px;

      canvas {
        width: auto;
        height: 100%;
      }
    }

    .close-btn {
      padding: 1em;
      display: block;
      width: 25px;
      height: auto;
      margin-left: auto;
      cursor: pointer;
    }
  }

  #preview__title {
    display: none;
    font-family: 'Bangers', 'Alegreya Sans', cursive;
    padding: 5px;
    font-size: 25px;
    color: #0095d4;
    letter-spacing: 1.5px;
    width: 100%;
    background-color: white;

  }



  .head-btn {
    width: 45px;
    height: 45px;
    padding: 5px;
    cursor: pointer;
    transition: all .2s ease-in-out;
    @media (max-width: 730px) {
      padding-top: 12px;
      width: 30px;
      height: 30px;
      padding-right: 3px;
    }
    @media (max-width: 560px) {
      width: 26px;
      height: 26px
    }
    @media (max-width: 355px) {
      width: 23px;
      height: 23px;
      padding-left: 3px;
    }
    @media (max-width: 325px) {
      width: 23px;
      height: 23px;
      padding-right: 3px;
      padding-left: 3px;
    }
  }

  .head-btn:active {

    transform: scale(1.2);
  }

  #head__right {
  }

  .footer-btn {
    padding-right: 0.5em;
    cursor: pointer;
    transition: all .2s ease-in-out;
    transform: scale(1);
    transform-origin: bottom;
  }

  .footer-btn:active {
    transform: scale(1.2);
  }

  .footer-btn__image {
    height: 100px;
    width: auto;
    pointer-events: none;
    margin: 0 auto;
    @media (hover: hover) {
      pointer-events: auto;
    }
  }

  .footer-btn__label {
    border: 2px solid #0095d4;
    border-radius: 10px;
    background-color: white;
    color: #0095d4;
    font-family: 'Open Sans', sans-serif;
    font-size: 12px;
    width: 120px;
    margin: 0 auto;
  }

  #editor-footer__item-slider {
    margin: 0 auto;
  }

  #item-select-overlay__slider {
  }

  .nav-item {
    width: 150px;
    height: 180px;
    box-sizing: border-box;
    cursor: pointer;
  }

  .nav-item:active {
    border: 1px solid red;
  }

  .nav-item img {
    height: 150px;
    width: auto;
    pointer-events: none;
    margin: 0 auto;
    @media (hover: hover) {
      pointer-events: auto;
    }
  }

  .nav-item-overlay-div {
    position: absolute;
    height: 100%;
    width: 100%;
    background-color: transparent;
  }

  .nav-item-shaddow {
    width: 100%;
    margin: 0 auto;
    padding-left: 10px;

    img {
      height: auto;
      width: 70%;
      pointer-events: none;
      margin: 0 auto;
      @media (hover: hover) {
        pointer-events: auto;
      }
    }
  }

  #bubble-editor-overlay {


  }

  #item-overlay {
    background: url('~@/assets/static/bg_overlay_preview_oder_themen-grid-auswahl.png');
    background-size: auto 100%;
    position: absolute;
    z-index: 999;
    width: 100%;
    background-color: #0095d4;
    //height: calc(100% - 270px);
    height: calc(100% - 10px);
    border-top: 1px solid white;
    padding-top: 1em;
    box-sizing: border-box;

    h2 {
      padding-top: 5px;
      color: white;
    }

    .close-btn {
      width: 50px;
      height: auto;
      position: absolute;
      right: 5px;
      cursor: pointer;
    }
  }

  .item-select-overlay {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 80%;
  }

  .overlay-box {

  }

  #background-editor {
    background: url('~@/assets/static/bg_overlay_preview_oder_themen-grid-auswahl.png');
    background-size: auto 100%;
    background-color: #0095d4;
    width: 100%;
    position: fixed;
    bottom: 0;
    color: white;
    font-family: 'Open Sans', sans-serif;
    height: 125px;
    z-index: 10;
    display: flex;
    align-items: center;
    justify-content: center;

    .button-big {
      margin: initial;
      padding: 12px;
      font-size: 15px;
      min-width: 50px;
      width: auto;
      margin-left: 5px;
      margin-right: 5px;
    }
  }
</style>
<style lang="scss">
  $handleSizeSmall: 13px;
  $handleSizeBig: 25px;
  .text-reader {

  }
  .preview-scaled{
    width: unset !important;
    height: auto !important;

  }
  .item-handle {
    background-color: red !important;
    width: $handleSizeSmall;
    height: $handleSizeSmall;
    position: absolute;
    box-sizing: border-box;
  }

  .item-handle-tl {
    top: -$handleSizeSmall;
    left: -$handleSizeSmall;
    cursor: nw-resize;
  }

  .item-handle-bl {
    bottom: -$handleSizeSmall;
    left: -$handleSizeSmall;
    cursor: sw-resize;
  }

  .item-handle-tr {
    top: -$handleSizeSmall;
    right: -$handleSizeSmall;
    cursor: ne-resize;
  }

  .item-handle-br {
    bottom: -$handleSizeSmall;
    right: -$handleSizeSmall;
    cursor: se-resize;
  }

  @media (max-width: 460px) {
    .item-handle {
      width: $handleSizeBig;
      height: $handleSizeBig;
    }
    .item-handle-tl {
      top: -$handleSizeBig;
      left: -$handleSizeBig;
      cursor: nw-resize;
    }
    .item-handle-bl {
      bottom: -$handleSizeBig;
      left: -$handleSizeBig;
      cursor: sw-resize;
    }
    .item-handle-tr {
      top: -$handleSizeBig;
      right: -$handleSizeBig;
      cursor: ne-resize;
    }
    .item-handle-br {
      bottom: -$handleSizeBig;
      right: -$handleSizeBig;
      cursor: se-resize;
    }
  }

  .activeItem {
    border: 1px solid red
  }


  .text-reader input {

  }

  .editor {
    height: 100vh;
    width: 100%;
    position: absolute;
    top: 0;
    overflow: hidden;
  }

  #editopr-wrapper {
    background-image: url("~@/assets/static/editor_back_bottom.jpg");
    height: calc(100vh - 68px - 66px);
    background-size: auto 100%;
    width: 100%;
    box-sizing: border-box;
  }

  #page-nav-header {
    @media (max-width: 525px) {
      display: none;
    }
  }

  #view-comic-btn {
    width: 120px;
    border-radius: 15px;
    font-family: 'Open Sans', sans-serif;
    background-color: white;
    color: #0095d4;
    position: absolute;
    bottom: -13px;
    z-index: 999;
    transform: translateX(-50%);
    left: 50%;
    box-shadow: 0px 0px 7px 3px rgba(130, 130, 130, 0.59);
    padding: 5px;
    padding-left: 13px;
    padding-right: 13px;
    cursor: pointer;
    @media (max-width: 450px) {
      font-size: 18px;
      padding-left: 20px;
      padding-right: 20px;
      width: 140px;

    }
    @media (min-width: 1000px) {
      font-size: 10px;
      padding-left: 8px;
      padding-right: 8px;

    }

  }

  #page-nav-footer {
    position: fixed;
    width: 100%;
    bottom: 135px;
    justify-content: center;

    @media (min-width: 525px) {
      display: none;
    }
  }

  .editor-pagenav-center {

    display: flex;
    align-self: center;
    align-items: center;

    .editor__pagenav__button {
      width: 45px;
      padding-top: 3px;
      @media (max-width: 730px) {

        width: 30px;

      }

      img {
        width: 100%;
        height: auto;
        cursor: pointer;

      }
    }

    .editor__pagenav__button--disabled {
      opacity: 0.5;
      pointer-events: none;
    }

    .editor__pagenav__label {
      background-color: white;
      color: #0095d4;
      border-radius: 20px;
      padding: 16px;
      font-family: 'Open Sans', sans-serif;
      margin-left: 1em;
      margin-right: 1em;
      @media (max-width: 730px) {
        padding: 10px;
        font-size: 12px;
        width: 60px;


      }
    }
  }

  #stage {
    width: 600px;
    height: 400px;
    transform-origin: 0% 0%;
    background-color: white;


  }

  #stage {
    box-sizing: border-box;
    position: absolute;
    top: 150px;
    left: 50%;
    box-shadow: 0px 0px 7px 3px rgba(130, 130, 130, 0.59);
  }

  #wrapper, #wrapper2 {
    width: 500px;
    height: 500px;
  }

  .page-container {

    width: 600px;
    height: 400px;
    overflow: hidden;
  }

  .page {
    position: relative;
    z-index: 10;
    width: 600px;
    height: 400px;
    overflow: hidden;

  }

  .page-container-page {
    width: 600px;
    height: 400px;
    position: relative;

  }

  .drag__element {

    position: absolute;
  }

  .drag__image {

  }

  .imageholder {
    margin: 0 auto;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    overflow: hidden;
    width: 600px;
    height: 400px;
  }

  .imageholder image {
    width: 100%;
    height: auto;
  }

  .imageholder img, .imageholder canvas {
    width: 100%;
    height: auto;
  }

  .drag__element__image {
    width: 100%;
    height: auto
  }

  .slideElement {

    background-color: red;
  }

  .editor-head {
    padding: 0.5em;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    background-image: url("~@/assets/static/editor_nav_bg.png");
    height: 68px;
    width: 100%;

  }

  .editor-footer {
    position: fixed;
    bottom: 0;
    left: 50%;
    left: 50%;
    height: 130px;
    width: calc(100% - 61px);
    transform: translateX(-50%);

    .slick-prev:before, .slick-next:before {
      color: #0095d4;
    }
  }

  .assets__image {
    width: 100px;
    height: auto;
  }

  .bg__image {
    width: 120px;
    height: auto;
  }

  .overflow-hidden {
    overflow: hidden;
  }
</style>
